<div class="progress-bar-div">
<!-- <p>{{qtyFilled}}</p> -->
<div class="progress">
  <div class = "progress-bar" [style.width.%] = getWidth></div>
</div>
</div>


